export class AssetRating {
    id: number = 0;
    kvaRating?: string;
    assetRatingId?: string;
    utilityId: number = 0;
}